var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudPage',{attrs:{"fetch-data":_vm.fetchData,"dialog":_vm.dialog,"columns":_vm.tableColumns,"listenToEvents":_vm.eventsToListen,"on-remove":_vm.remove}})
}
var staticRenderFns = []

export { render, staticRenderFns }